export default {
  meta: {
    title: '一鸣决策报告',
    parentPath: '/share',
    breadcrumbs: [],
  },
};
